import React from 'react';
import { Info } from 'lucide-react';

/** Quiet informational callout (helper text that explains how a table/chart is computed). */
export default function InfoNote({ children, className = '' }) {
    return (
        <div className={`flex items-start gap-2 rounded-lg border border-info-border bg-info-bg px-3 py-2 text-[13px] text-info-fg ${className}`}>
            <Info className="mt-0.5 shrink-0 text-sm" />
            <span>{children}</span>
        </div>
    );
}
